<div class="property_manager_wrapper">
    <div class="property_manager_header_wrapper">
        <div class="row  property_manager_header_row">
            <div class="col-lg-7 col-md-8 col-sm-12 col-12 property_manager_header_col">
                <h1 class="header_title">A Prop Tech Residential Real Estate Rental & Property Management Company</h1>
                <div class="header_button_wrapper">
                    <!-- <div class="header_button">
                        <a class="header_button_cnt" href="/login">Property Manager Login</a>           
                    </div> -->
                </div>
            </div>
            <div class="col-lg-5 col-md-6 d-lg-flex d-none property_manager_header_img_wrapper">
                <img src="assets/images/owner img.jpg " class="header_img img-responsive" alt="YourOwnrROOM : Home Owners" />
            </div>
        </div>
    </div>
    <!-- Residential Rental Mangement -->
    <div style="padding-top: 32px;">
        <h1 class="section-heading "> Project Management Services </h1>
        <!-- service offerings -->
        <div class="service-catalogue">
            <h2 class="section-heading " style="margin: 0 !important;">Service Offerings</h2>
            <div class="row justify-content-around" style="padding: 0px 12px;">
                <div class="col-lg-5  col-md-6 col-12 catalogue-item">
                    <img class="img-responsive catalogue-item-img" src="assets/images/homeowners/Painting solution.jpg" />
                    <h2 class="catalogue-subheading">Painting & POP Projects</h2>
                    <div class="catalogue-underline"></div>
                    <div class="catalogue-item-list">
                        <p class="catalogue-item-list-item"> • Large scale painting - Exterior & Interior.</p>
                        <p class="catalogue-item-list-item"> • POP</p>
                        <p class="catalogue-item-list-item"> • False ceiling work</p>
                    </div>
                </div>
                <div class="col-lg-5 col-md-6 col-12 catalogue-item">
                    <img class="img-responsive catalogue-item-img" src="assets/images/homeowners/Interiors & Project Solutions.jpg" />
                    <h2 class="catalogue-subheading">Civil & Fabrication Projects </h2>
                    <div class="catalogue-underline"></div>
                    <div class="catalogue-item-list">
                        <p class="catalogue-item-list-item"> • Civil finishing work</p>
                        <p class="catalogue-item-list-item"> • Tiling/Granite Laying</p>
                        <p class="catalogue-item-list-item"> • Super structure block work</p>
                        <p class="catalogue-item-list-item"> • Fabrication</p>
                        <p class="catalogue-item-list-item"> • Landscaping</p>
                    </div>
                </div>
                <div class="col-lg-5 col-md-6 col-12 catalogue-item">
                    <img class="img-responsive catalogue-item-img" src="assets/images/homeowners/On-demand Services.jpg" />
                    <h2 class="catalogue-subheading">Facilities mangement AMC</h2>
                    <div class="catalogue-underline"></div>
                    <div class="catalogue-item-list">
                        <p class="catalogue-item-list-item"> • Security services</p>
                        <p class="catalogue-item-list-item"> • Housekeeping services</p>
                        <p class="catalogue-item-list-item"> • Electrical & plumbing services</p>
                        <p class="catalogue-item-list-item"> • Landscaping maintenance</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="service-htw-wrapper">
            <h2 class="section-heading">How it works</h2>
            <div class="row justify-content-md-between justify-content-center">
                <div class="col-lg-4 col-md-6 col-12 htw">
                    <div class="hiw-img-wrapper">
                        <img src="assets/images/owners/sign mou.jpg" alt="YourOwnROOM - Property" class="img-responsive catalogue-item-img htw-img">
                      </div>
                    <h1 class="htw-subheading">1.Scope Requirements</h1>
                    <p class="service-offering-details" style="margin-bottom: 20px">
                        <strong>-</strong> Capture scope and submit proposals.
                    </p>
                    <p class="service-offering-details" style="margin-bottom: 20px">
                        <strong>-</strong> Negotiate proposal.
                    </p>
                    <p class="service-offering-details" style="margin-bottom: 20px">
                        <strong>-</strong> Base line scope, cost, timeline, identify milestones & dependencies
                    </p>
                    <p class="service-offering-details" style="margin-bottom: 20px">
                        <strong>-</strong> Finalize payment terms.
                    </p>
                    <p class="service-offering-details" style="margin-bottom: 20px">
                        <strong>-</strong> Issue work order or SOW.
                    </p>
                </div>
                
                <div class="col-lg-4 col-md-6 col-12 htw">
                    <div class="hiw-img-wrapper">
                        <img src="assets/images/owners/onboard property.jpg" alt="YourOwnROOM - Property" class="img-responsive catalogue-item-img htw-img"  >
                      </div>
                    <h1 class="htw-subheading">2. Project Kick-off</h1>
                        <p class="service-offering-details" style="margin-bottom: 20px">
                            <strong>-</strong> Sign contract.
                        </p>
                        <p class="service-offering-details" style="margin-bottom: 20px">
                            <strong>-</strong> Issue advance.
                        </p>
                        <p class="service-offering-details" style="margin-bottom: 20px">
                            <strong>-</strong> Mobilize man power and resources and kick-off project.
                        </p>
                </div>
                <div class="col-lg-4 col-md-6 col-12 htw">
                    <div class="hiw-img-wrapper">
                        <img src="assets/images/owners/manage property.jpg" alt="YourOwnROOM - Property" class="img-responsive catalogue-item-img htw-img">
                    </div>
                    <h1 class="htw-subheading">3. Manage Project</h1>
                    <p class="service-offering-details" style="margin-bottom: 20px">
                        <strong>-</strong> Monitor and track project on a day-to-day basis.
                    </p>
                    <p class="service-offering-details" style="margin-bottom: 20px">
                        <strong>-</strong> Get regular updates and status from project manager.
                    </p>
                    <p class="service-offering-details" style="margin-bottom: 20px">
                        <strong>-</strong> Achieve milestones and obtain customer sign-off.
                    </p>
                    <p class="service-offering-details" style="margin-bottom: 20px">
                        <strong>-</strong> Raise invoice based on payment terms.
                    </p>
                    <p class="service-offering-details" style="margin-bottom: 20px">
                        <strong>-</strong> Submit project completion report and close project.
                    </p>
                </div>
            </div>
        </div>
    </div>
    

    <div class="services-tabs">         
        
        <div class="service-proptech-sm" style="margin-top: 80px; margin-bottom: 32px;">
            <h1 class="section-heading2" style="width: 100%; text-align: center; margin-bottom: 56px;">INTEGRATED REAL ESTATE PLATFORM</h1>
            <div class="row">
                <div class="col-md-12 col-sm-12">
                    <h3 class="proptech-content" style="text-align: center">Offering end-end property journey from listing your property online, searching verified tenants, digital service request management, tracking rental payments, property audits, renewals and online tenant settlements. Manage your Property through the Owner Dashboard on our Portal and Mobile App.</h3>
                    
                </div>
                <div class="col-md-6 col-sm-6 col-6">
                    <img src="assets/images/proptech/ownerdb1.jpg" alt="YourOwnROOM - Owner Dashboard" class="proptech-img img-responsive">
                </div>
                <div class="col-md-6 col-sm-6 col-6" style="display: flex; justify-content: flex-end;">
                    <img src="assets/images/proptech/ownerdb2.jpg" alt="YourOwnROOM - Owner Dashboard" class="proptech-img img-responsive">
                </div>
            </div>
            <a class="googleplay-wrapper"  href="https://play.google.com/store/apps/details?id=com.yourownroom.yorapp" target="_blank"><img style="margin-top: 32px !important;" src="assets/images/googleplay.png" class="googleplay img-responsive" /></a>
        </div>
    </div>
    <!-- COMPLETED PROJECTS -->
    <div class="service-htw-wrapper" style="margin-top: 120px;">
        <h1 class="section-heading2 section-head-text-align">Successful Projects - Bengaluru</h1> 
        <div class="row  justify-content-center">
            <!-- Project 1 -->
            <div class="col-xl-3 col-lg-4 col-md-5 col-sm-7 col-10 completed_projects">
                <div class="project-img-wrapper">
                    <img src="assets/images/completed projects/ECITY/After/EC_CP2.png" alt="YourOwnROOM - Projects" class="img-responsive  project-img"  >
                </div>
                <h2 class="project-desp">5,000 sq.ft. Pergola installation and civil work and painting for premium villa at Address Maker.
                    <br>
                    <fa-icon [icon]="faMapPin" style="color: salmon" class="fa-sm" ></fa-icon>
                    Electronic City, Banglore.
                </h2>
                <div class="catalogue-underline"></div>
                <p class="view_project_img" data-toggle="modal" data-target="#EcModal">View all images</p>
            </div>
            <!-- Project 2 -->
            <div class="col-xl-3 col-lg-4 col-md-5 col-sm-7 col-10 completed_projects offset-lg-1 offset-md-1 offset-sm-0">
                <div>
                    <div class="project-img-wrapper" style="justify-content: space-evenly;">
                        <img src="assets/images/completed projects/Sarjapur/After/SP_CP3.png" alt="YourOwnROOM - Projects" class="img-responsive project-img"  >
                    </div>
                    <h2 class="project-desp">
                        2,000 sqft Pergola installation and civil work and painting for a premium villa at Address Maker.
                        <br> 
                        <fa-icon [icon]="faMapPin" style="color: salmon" class="fa-sm" ></fa-icon>
                        Sarjapur, Bangalore.
                    </h2>
                    <div class="catalogue-underline"></div>
                </div>
                <div>
                    <p class="view_project_img" data-toggle="modal" data-target="#SpModal">View all images</p>
                </div>
            </div>
            <!-- Project 3 -->
            <div class="col-xl-3 col-lg-4 col-md-5 col-sm-7 col-10 offset-xl-1 offset-lg-0 offset-md-0 offset-sm-0 completed_projects">
                <div class="project-img-wrapper">
                    <img src="assets/images/completed projects/HSR/ECenter1.jpeg" alt="YourOwnROOM - Projects" class="img-responsive  project-img"  >
                </div>
                <h2 class="project-desp">Building terrace garden experience centre across 1000 sqft for a premium interior company
                    <br>
                    <fa-icon [icon]="faMapPin" style="color: salmon" class="fa-sm" ></fa-icon>
                    HSR Layout, Banglore.
                </h2>
                <div class="catalogue-underline"></div>
                <p class="view_project_img" data-toggle="modal" data-target="#HSRModal">View all images</p>
            </div>
            <!-- Project 4 -->
            <div class="col-xl-3 col-lg-4 col-md-5 col-sm-7 col-10 offset-xl-0 offset-lg-1 offset-md-1 offset-sm-0 completed_projects">
                <div>
                    <div class="project-img-wrapper">
                        <img src="assets/images/completed projects/MITS/MITS1.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-img"  >
                    </div>
                    <h2 class="project-desp">1,000 sqft Pergola installation and civil work and painting for Nambiar Villa.
                        <br>
                        <fa-icon [icon]="faMapPin" style="color: salmon" class="fa-sm" ></fa-icon>
                        Sarjapur, Banglore.
                    </h2>
                    <div class="catalogue-underline"></div>
                </div>
                <div>
                    <p class="view_project_img" data-toggle="modal" data-target="#MITSModal">View all images</p>
                </div>
                
                
            </div>
            <!-- Project 5 -->
            <div class="col-xl-3 col-lg-4 col-md-5 col-sm-7 col-10 offset-xl-1 offset-lg-0 offset-md-0 offset-sm-0 completed_projects">
                <div>
                    <div class="project-img-wrapper">
                        <img src="assets/images/completed projects/APR/APR2.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-img"  >
                    </div>
                    <h2 class="project-desp">2,000 sqft Pergola installation and civil work and painting in Adarsh Palm Retreat Villa.
                        <br>
                        <fa-icon [icon]="faMapPin" style="color: salmon" class="fa-sm" ></fa-icon>
                        Sarjapur, Banglore.
                    </h2>
                    <div class="catalogue-underline"></div>
                </div>
                <div>
                    <p class="view_project_img" data-toggle="modal" data-target="#APRModal">View all images</p>
                </div>
            </div> 
        </div>
    </div>
    <div class="service-htw-wrapper" style="margin-top: 120px;">
        <h1 class="section-heading2 section-head-text-align">Successful Projects - Pune</h1> 
        <div class="row  justify-content-center">
            <!-- Project 6 -->
            <div class="col-xl-3 col-lg-4 col-md-5 col-sm-7 col-10 offset-lg-1 completed_projects">
                <div>
                    <div class="project-img-wrapper">
                        <img src="assets/images/completed projects/Pune_MIT/PUNMIT1.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-img"  >
                    </div>
                    <h2 class="project-desp">Exterior painting of close to 6 lakh sq.ft. across three seven storey blocks and tile installations and civil work for a leading reputed institute.
                        <br>
                        <fa-icon [icon]="faMapPin" style="color: salmon" class="fa-sm" ></fa-icon>
                        Pune.
                    </h2>
                    <div class="catalogue-underline"></div>
                </div>
                <div>
                    <p class="view_project_img" data-toggle="modal" data-target="#MITModal">View all images</p>
                </div>
            </div>
            <!-- Project 7 -->
            <div class="col-xl-3 col-lg-4 col-md-5 col-sm-7 col-10 offset-lg-1 offset-md-1 offset-sm-0 completed_projects">
                <div class="project-img-wrapper">
                    <img src="assets/images/completed projects/Pune_P2/PuneP2_1.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-img"  >
                </div>
                <h2 class="project-desp">Exterior painting of 2 lakh sq.ft. across two six storey blocks for a leading reputed institute
                    <br>
                    <fa-icon [icon]="faMapPin" style="color: salmon" class="fa-sm" ></fa-icon>
                    Pune.
                </h2>
                <div class="catalogue-underline"></div>
            </div>
            <!-- Project 8 -->
            <div class="col-xl-3 col-lg-4 col-md-5 col-sm-7 col-10 offset-lg-1 offset-md-1 offset-sm-0 completed_projects">
                <div class="project-img-wrapper">
                    <img src="assets/images/completed projects/Barclays/Barclays1.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-img"  >
                </div>
                <h2 class="project-desp">POP and false ceiling work of 1 lakh sq.ft. for a 14 storey building for a multinational bank in
                    <br>
                    <fa-icon [icon]="faMapPin" style="color: salmon" class="fa-sm" ></fa-icon>
                    Kharadi, Pune.
                </h2>
                <div class="catalogue-underline"></div>
            </div>
        </div>
    </div>
    
    <!--SECTION -> In The News -->
    <div class="news-section">        
        <h1 class="section-heading2 section-head-text-align">  In the News  </h1>   
        <div class="news_details_wrapper">
            <div class="yor_news" id="news_carousal">
                <div class="news col-12 col-lg-3 col-md-4">
                    <a href="https://startupstorymedia.com/startuptv/prop-tech-is-the-new-growth-catalyst-in-residential-real-estate-prabhat-kumar-tiwary-yourownroom/" target="_blank">
                        <img src="assets/images/news/startup-story.png" alt="YourOwnROOM News" style="width: 140px;">
                    </a>
                </div>
                <div class="news col-12 col-lg-3 col-md-4">
                    <a href="https://yourstory.com/2017/02/yourownrooms-mantra-for-profitable-scaling/" target="_blank">
                        <img src="assets/images/news/news_yourstory.png" alt="YourOwnROOM News">
                    </a>
                </div>
                <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                    <a href="http://bwdisrupt.businessworld.in/article/YourOwnRoom-a-750K-Seed-Funded-Co-living-Home-Rental-Company-Expands-Footprint-in-Bangalore-Pune/08-10-2018-161713/" target="_blank">
                        <img src="assets/images/news/news_full-Disrupt-logo.png" alt="YourOwnROOM News">
                    </a>
                </div>
                <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                    <a href="http://www.deccanherald.com/content/594969/yourownroom-helps-singles-find-their.html" target="_blank">
                        <img src="assets/images/news/news_deccan.jpeg" alt="YourOwnROOM News">
                    </a>
                </div>
                <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                    <a href="https://thetechpanda.com/2017/10/04/startup-millennials-apartments/" target="_blank">
                        <img src="assets/images/news/news_TheTechPanda.png" alt="YourOwnROOM News">
                    </a>
                </div>
                <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                    <a href="http://www.siliconindia.com/magazine/startup-of-the-year-special-october-2016/" target="_blank">
                        <img src="assets/images/news/news_siliconindia.gif" alt="YourOwnROOM News">
                    </a>
                </div>
                <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                    <a href="https://www.indianweb2.com/search?q=yourownroom" target="_blank">
                        <img src="assets/images/news/news_indianweb2.png" alt="YourOwnROOM News">
                    </a>
                </div>
                <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                    <a href="https://m.dailyhunt.in/news/india/english/yourstory-epaper-yourstory/amid+coronavirus+how+proptech+rental+yourownroom+is+handling+tenants+and+scaling+up+its+platform-newsid-n177954266" target="_blank">
                        <img src="assets/images/news/news_dailyhunt.png" alt="YourOwnROOM News">
                    </a>
                </div>
                <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                    <a href="https://www.onlinemarketplaces.com/?s=yourownroom" target="_blank">
                        <img src="assets/images/news/news_propertyportal.png" alt="YourOwnROOM News">
                    </a>
                </div>
                <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                    <a href="http://epaper.prabhatkhabar.com/c/10229063" target="_blank">
                        <img src="assets/images/news/news_prabhatkhabar.jpg" alt="YourOwnROOM News">
                    </a>
                </div>
                <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                    <a href="http://www.bangaloreinsider.com/yourownroom/" target="_blank">
                        <img src="assets/images/news/bangalore-insider.png">
                    </a>
                </div>
                <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                    <a href="http://www.thenewsminute.com/article/new-breed-startups-wants-solve-problems-house-renters-65949" target="_blank">
                        <img src="assets/images/news/news_thenewsmnt.jpg" >
                    </a>
                </div>
                <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                    <a href="https://www.bitosaglobal.org/news/14654" target="_blank">
                        <img src="assets/images/news/bitosa_logo.png" >
                    </a>
                </div>
                <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                    <a href="https://paulwriter.com/paul-writer-unveiled-namma-bengaluru-hot-brands-2019/" target="_blank">
                        <img src="assets/images/news/Paulwriter.png">
                    </a>
                </div>
            </div>
        </div>
        <div>
            <div class="scroll_indicator_wrapper news-indicator">
                <img src="assets/images/left-arrow.svg" (click)="newsLeft()" class="scroll_indicator_left" alt="Residential Real Estate Asset Management Company">
                <img src="assets/images/right-arrow.svg" (click)="newsRight()" class="scroll_indicator_right" alt="Residential Real Estate Asset Management Company">
            </div>
        </div>
    </div>
  
    <!-- SECTION -> BLOGS & ARTICLES -->
    <div class="blog-wrapper">        
        <h1 class="section-heading2 section-head-text-align"> Blogs & Articles  </h1>   
        <div class="blog_container">
            <div class="blogs_wrapper" id="blogs_carousal">
                <div class="col-lg-4 blog_card" >
                    <div class="blog_img_wrapper">
                        <div class="blog_img_inner_wrapper">
                        <img src="../../assets/images/guest_article_img_1.jpg" class="blog_img" alt="Yourownroom Guest Articles and Blogs">
                        </div>
                    </div>
                    <div class="blog_detail">
                        <a class="blog_head" href="http://www.businessworld.in/article/De-mystifying-REIT-Real-Estate-Investment-Trust/24-08-2021-401576/" target="_blank">De-mystifying REIT: Real Estate Investment Trust</a>
                        <p class="blog_body">Real Estate Investment Trusts (REITs) are undoubtedly the safest investment options in the Indian market today. However...</p>
                    </div>
                </div>
                <div class="col-lg-4 blog_card" >
                    <div class="blog_img_wrapper">
                        <div class="blog_img_inner_wrapper">
                        <img src="../../assets/images/sachinblogjpeg.jpeg" class="blog_img" alt="Yourownroom Guest Articles and Blogs">
                        </div>
                    </div>
                    <div class="blog_detail">
                        <a class="blog_head" href="https://tail-winds.medium.com/the-end-of-real-estate-silos-welcome-surveillance-d24d749f77d8" target="_blank">Rental & Property Management Companies</a>
                        <p class="blog_body">The End of Real Estate ‘Silos’ -Welcome Surveillance...</p>
                    </div>
                </div>
                <div class="col-lg-4 blog_card" >
                    <div class="blog_img_wrapper">
                        <div class="blog_img_inner_wrapper">
                        <img src="../../assets/images/griclub.jpg" class="blog_img" alt="Yourownroom Guest Articles and Blogs">
                        </div>
                    </div>
                    <div class="blog_detail">
                        <a class="blog_head" href="https://www.griclub.org/news/real-estate/rental-property-management-companies_1584.html" target="_blank">Rental & Property Management Companies</a>
                        <p class="blog_body">Real estate industry in India is expected to grow five-fold to $1 trillion by 2030 and a significant percentage of this is Residential Real Estate...</p>
                    </div>
                </div>
                <div class="col-lg-4 blog_card" >
                    <div class="blog_img_wrapper">
                        <div class="blog_img_inner_wrapper">
                        <img src="../../assets/images/blog10.jpg" class="blog_img" alt="Yourownroom Guest Articles and Blogs">
                        </div>
                    </div>
                    <div class="blog_detail">
                        <a class="blog_head" href="http://www.businessworld.in/article/Decoding-Model-Tenancy-Act/09-07-2021-395999/" target="_blank">Decoding Model Tenancy Act</a>
                        <p class="blog_body">Acts like RERA and Model Tenancy are now finalized, ready to set the housing sector right. While RERA was more focused around formalizing and building trust ...</p>
                    </div>
                </div>
                <div class="col-lg-4 blog_card" >
                    <div class="blog_img_wrapper">
                        <div class="blog_img_inner_wrapper">
                        <img src="https://i2.wp.com/prabhatkumartiwary.com/wp-content/uploads/2021/06/RERA-YOR.jpeg?resize=294%2C171&ssl=1" class="blog_img" alt="Yourownroom Guest Articles and Blogs">
                        </div>
                    </div>
                    <div class="blog_detail">
                        <a class="blog_head" href="http://www.businessworld.in/article/How-RERA-Is-Changing-The-Landscape-of-Residential-Real-Estate-/17-06-2021-393482/" target="_blank">How RERA Is Changing The Landscape Of Residential Real Estate?</a>
                        <p class="blog_body">With the prevailing discrepancies and issues in India's real estate sector, a concrete step was taken by the...</p>
                    </div>
                </div>
                <div class="col-lg-4 blog_card">
                    <div class="blog_img_wrapper">
                        <div class="blog_img_inner_wrapper">
                        <img src="https://i1.wp.com/prabhatkumartiwary.com/wp-content/uploads/2021/03/Prabhat-guest-post-4.png?resize=400%2C250&ssl=1" class="blog_img" alt="Yourownroom Guest Articles and Blogs">
                        </div>
                    </div>
                    <div class="blog_detail">
                        <a href="https://yourstory.com/2021/01/challenges-residential-real-estate-proptech/amp" class="blog_head">The Many Challenges in Residential Real Estate</a>
                        <p class="blog_body">In the early 2000s, general euphoria engulfed the Nation, especially the youth, induced by bright new...</p>
                    </div>
                </div>
                <div class="col-lg-4 blog_card">
                    <div class="blog_img_wrapper">
                        <div class="blog_img_inner_wrapper">
                        <img src="https://i1.wp.com/prabhatkumartiwary.com/wp-content/uploads/2021/03/Prabhat-gues-post-3.jpeg?resize=400%2C250&ssl=1" class="blog_img" alt="Yourownroom Guest Articles and Blogs">
                        </div>
                    </div>
                    <div class="blog_detail">
                        <a href="https://www.peoplematters.in/site/interstitial?return_to=%2Fblog%2Flife-at-work%2Fhome-is-the-defacto-workplace-and-wfh-the-new-normal-25523" class="blog_head">Home is the defacto workplace and “WFH” the new normal!</a>
                        <p class="blog_body">Did we ever think that words like “Social Distance”, “Lockdown” and “Quarantine” will become such an...</p>
                    </div>
                </div>
                <div class="col-lg-4 blog_card">
                    <div class="blog_img_wrapper">
                        <div class="blog_img_inner_wrapper">
                        <img src="https://miro.medium.com/max/1494/1*6y6NCuTanOofKe9MRTh_gQ.png" class="blog_img" alt="Yourownroom Blogs">
                        </div>
                    </div>
                    <div class="blog_detail">
                        <a class="blog_head" href="https://tail-winds.medium.com/the-return-of-indian-residential-real-estate-2dc01ff4b656" target="_blank">The Return of Indian Residential Real Estate</a>
                        <p class="blog_body">The property rates in India between 2000–2010 grew by 52%( in leading 7 cities). Decade after that it has grown only by 32% […]</p>
                    </div>
                </div>
                <div class="col-lg-4 blog_card">
                    <div class="blog_img_wrapper">
                        <div class="blog_img_inner_wrapper">
                        <img src="https://yourownroom.com/blog/wp-content/uploads/2020/03/The-outbreak-of-the-coronavirus-and-preventive-measures-that-one-should-follow.png" class="blog_img" alt="Yourownroom Blogs">
                        </div>
                    </div>
                    <div class="blog_detail">
                        <a href="https://yourownroom.com/blog/outbreak-coronavirus-preventive-measures-one-follow/" class="blog_head">The Outbreak Of the Coronavirus and Preventive Measures</a>
                        <p class="blog_body">From dropped conferences to shutdowns of hardware suppliers, the deadly […]</p>
                    </div>
                </div>
                <div class="col-lg-4 blog_card">
                    <div class="blog_img_wrapper">
                        <div class="blog_img_inner_wrapper">
                        <img src="https://yourownroom.com/blog/wp-content/uploads/2019/12/Untitled.jpg" class="blog_img" alt="Yourownroom Blogs">
                        </div>
                    </div>
                    <div class="blog_detail">
                        <a href="https://yourownroom.com/blog/your-own-room-indias-co-living-market/" class="blog_head">What Takes YourOwnRoom to India’s $6.5B Co-Living Market</a>
                        <p class="blog_body">India’s rapidly growing co-living market is currently valued at $6.5 billion, and is […]</p>  
                    </div>
                </div>
            </div>
        </div>
        <div >
            <div class="scroll_indicator_wrapper">
                <img src="assets/images/left-arrow.svg" (click)="blogLeft()" class="scroll_indicator_left" alt="Residential Real Estate Asset Management Company">
                <img src="assets/images/right-arrow.svg" (click)="blogRight()" class="scroll_indicator_right" alt="Residential Real Estate Asset Management Company">
            </div>
        </div>        
    </div>
</div>


<div class="modal fade" id="SpModal" tabindex="-1" aria-labelledby="devModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
          <div class="modal-header">
            <div class="modal-body">
                <h2>Before : </h2>
                <div class="row">
                    <div class="col-lg-4">
                        <img src="assets/images/completed projects/Sarjapur/Before/SP_BCP1.png" alt="YourOwnROOM - Projects" class="img-responsive  project2-slide-images"  >
                    </div>
                    <div class="col-lg-4">
                        <img src="assets/images/completed projects/Sarjapur/Before/SP_BCP2.png" alt="YourOwnROOM - Projects" class="img-responsive  project2-slide-images"  >
                    </div>
                    <div class="col-lg-4">
                        <img src="assets/images/completed projects/Sarjapur/Before/SP_BCP3.png" alt="YourOwnROOM - Projects" class="img-responsive  project2-slide-images"  >
                    </div>
                    
                </div>
                <h2 style="margin-top: 16px;">After : </h2>
                <div class="row">
                    <div class="col-lg-4">
                        <img src="assets/images/completed projects/Sarjapur/After/SP_CP1.png" alt="YourOwnROOM - Projects" class="img-responsive  project2-slide-images"  >
                    </div>
                    <div class="col-lg-4">
                        <img src="assets/images/completed projects/Sarjapur/After/SP_CP2.png" alt="YourOwnROOM - Projects" class="img-responsive  project2-slide-images"  >
                    </div>
                    <div class="col-lg-4">
                        <img src="assets/images/completed projects/Sarjapur/After/SP_CP3.png" alt="YourOwnROOM - Projects" class="img-responsive  project2-slide-images"  >
                    </div>
                    <div class="col-lg-4" style="margin-top: 16px;">
                        <img src="assets/images/completed projects/Sarjapur/After/SP_CP4.png" alt="YourOwnROOM - Projects" class="img-responsive  project2-slide-images"  >
                    </div>
                </div>
            </div>
          </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="EcModal" tabindex="-1" aria-labelledby="devModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
          <div class="modal-header">
            <div class="modal-body">
                <h2>Before : </h2>
                <div class="row">
                    <div class="col-lg-4">
                        <img src="assets/images/completed projects/ECITY/Before/EC_BCP1.png" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-4">
                        <img src="assets/images/completed projects/ECITY/Before/EC_BCP2.png" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-4">
                        <img src="assets/images/completed projects/ECITY/Before/EC_BCP3.png" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    
                </div>
                <h2 style="margin-top: 16px;">After : </h2>
                <div class="row">
                    <div class="col-lg-4">
                        <img src="assets/images/completed projects/ECITY/After/EC_CP1.png" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-4">
                        <img src="assets/images/completed projects/ECITY/After/EC_CP2.png" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-4">
                        <img src="assets/images/completed projects/ECITY/After/EC_CP3.png" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-4" style="margin-top: 16px;">
                        <img src="assets/images/completed projects/ECITY/After/EC_CP4.png" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                </div>
            </div>
          </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="HSRModal" tabindex="-1" aria-labelledby="devModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
          <div class="modal-header">
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-4">
                        <img src="assets/images/completed projects/HSR/ECenter1.jpeg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-4" >
                        <img src="assets/images/completed projects/HSR/ECenter2.jpeg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-4" >
                        <img src="assets/images/completed projects/HSR/ECenter4.jpeg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-6" style="margin-top: 16px;">
                        <img src="assets/images/completed projects/HSR/ECenter3.jpeg" alt="YourOwnROOM - Projects" class="img-responsive  project3-slide-images"  >
                    </div>
                </div>
            </div>
          </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="MITSModal" tabindex="-1" aria-labelledby="devModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
          <div class="modal-header">
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-3">
                        <img src="assets/images/completed projects/MITS/MITS1.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-3" >
                        <img src="assets/images/completed projects/MITS/MITS3.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-3">
                        <img src="assets/images/completed projects/MITS/MITS4.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-3">
                        <img src="assets/images/completed projects/MITS/MITS6.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-6" style="margin-top: 16px;">
                        <img src="assets/images/completed projects/MITS/MITS5.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                </div>
            </div>
          </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="APRModal" tabindex="-1" aria-labelledby="devModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
          <div class="modal-header">
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-3">
                        <img src="assets/images/completed projects/APR/APR1.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-3" >
                        <img src="assets/images/completed projects/APR/APR2.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-3">
                        <img src="assets/images/completed projects/APR/APR3.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-3">
                        <img src="assets/images/completed projects/APR/APR4.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-3" style="margin-top: 16px;">
                        <img src="assets/images/completed projects/APR/APR5.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-3" style="margin-top: 16px;">
                        <img src="assets/images/completed projects/APR/APR6.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-3" style="margin-top: 16px;">
                        <img src="assets/images/completed projects/APR/APR7.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-3" style="margin-top: 16px;">
                        <img src="assets/images/completed projects/APR/APR8.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-3" style="margin-top: 16px;">
                        <img src="assets/images/completed projects/APR/APR9.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    
                </div>
            </div>
          </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="MITModal" tabindex="-1" aria-labelledby="devModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
          <div class="modal-header">
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-6">
                        <img src="assets/images/completed projects/Pune_MIT/PUNMIT1.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-6">
                        <img src="assets/images/completed projects/Pune_MIT/PUNMIT2.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-6" style="margin-top: 16px;">
                        <img src="assets/images/completed projects/Pune_MIT/PUNMIT3.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-6"style="margin-top: 16px;">
                        <img src="assets/images/completed projects/Pune_MIT/PUNMIT4.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-4" style="margin-top: 16px;">
                        <img src="assets/images/completed projects/Pune_MIT/PUNMIT5.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                </div>
            </div>
          </div>
      </div>
    </div>
  </div>